import axios from 'axios';

export default {
    namespaced: true,

    state: {
        sidebar: [],
        sidebarLoader: false,
        sidebarMounted: false,
    },

    mutations: {
        setSidebarLoader(state, value) {
            state.sidebarLoader = value;
        },

        setSidebarMounted(state, value) {
            state.sidebarMounted = value;
        },

        setSidebar(state, value) {
            state.sidebar = value;
        }
    },

    actions: {
        getSidebar({ commit }) {
            return new Promise((resolve) => {
                axios.get('/sanctum/csrf-cookie')
                    .then(() => {
                        axios.get('/api/sidebar')
                            .then((response) => {
                                commit('setSidebar', response.data);
                                commit('setSidebarLoader', false);
                                commit('setSidebarMounted', true);
                                resolve();
                            });
                    });
            });
        }
    }
};
